function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "runways");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Flight-interactive",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Plane-talking---Desktop-/-Explainer-/-Runways",
  transform: "translate(-527.000000, -136.000000)"
}, React.createElement("g", {
  id: "runways",
  transform: "translate(526.018595, 136.042627)"
}, React.createElement("g", {
  id: "wind-sock",
  transform: "translate(208.981405, 186.957373)"
}, React.createElement("path", {
  d: "M0.90929,2.74886 L4.03679,2.74886",
  id: "Path",
  stroke: "#145569",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M0.90929,6.65252 L4.03679,6.65252",
  id: "Path",
  stroke: "#145569",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M0.90929,23.24035 L0.90929,0.5",
  id: "Path",
  stroke: "#FFFFFF",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M5.01727,0.64832 C4.77158617,0.611150613 4.52190858,0.682973377 4.3335278,0.845006671 C4.14514702,1.00703997 4.03681,1.24317041 4.03681,1.49165 L4.03681,7.90974 C4.03681,8.1582144 4.14516423,8.39433565 4.33354203,8.55636445 C4.52191982,8.71839326 4.77158978,8.79021856 5.01727,8.75306 L8.44367,8.23469 L8.44367,1.1667 L5.01727,0.64832 Z",
  id: "Path",
  fill: "#E66E0A",
  fillRule: "nonzero"
}), React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "8.444 1.167 8.444 8.235 12.85 7.568 12.85 1.833"
}), React.createElement("path", {
  d: "M16.53174,2.39027 L12.85046,1.83338 L12.85046,7.568 L16.53174,7.01112 C16.9487661,6.94799694 17.25708,6.58956635 17.25708,6.16779 L17.25708,3.23359 C17.25708,2.81179536 16.9487931,2.45333692 16.53174,2.39027 Z",
  id: "Path",
  fill: "#E66E0A",
  fillRule: "nonzero"
})))));

var SvgWindSock = function SvgWindSock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 415 401",
    width: 415,
    height: 401,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWindSock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/windSock.5c10826c.svg";
export { ForwardRef as ReactComponent };